import "./RevenueAnalytics.scss";
import { Pie, PieChart, ResponsiveContainer, Cell, Tooltip } from "recharts";
import RevenueAnalyticsLogic from "./RevenueAnalyticsLogic";
import Images from "../../../assets/images";
import { formatCurrency, getPlatform } from "../../../helpers";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { platformHandler } from "../../../hooks/context";
import { useSelector } from "react-redux";

const RevenueTooltip = ({ active, payload, sumOfTags }) => {
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  if (active) {
    return (
      <div className="revenue-chart-tooltip">
        <p className="dark--text" style={{ fontSize: "13px" }}>
          {payload[0].name}
        </p>
        <p className="purple--text" style={{ fontSize: "12px" }}>
          {formatCurrency({
            value: payload[0].value,
            currencyCode: currency_code,
          })}
        </p>
        <p style={{ fontSize: "12px", color: "#FD561F" }}>
          {((payload[0].value / sumOfTags) * 100).toFixed(2)}%
        </p>
      </div>
    );
  }
  return null;
};

const RevenueAnalytics = ({ tagsData }) => {
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { data, COLORS, sumOfTags } = RevenueAnalyticsLogic({ tagsData });
  const { platform } = useContext(platformHandler);

  return (
    <div className="revenue-analytics">
      <h5 style={{ fontSize: "20px" }} className="font-weight-semibold mb-0">
        Revenue
      </h5>
      <p style={{ fontSize: "13px" }}>
        <span>Vist </span>
        <Link
          style={{ fontSize: "13px" }}
          to={getPlatform(platform) + "/transactions?all_business=true"}
          className="purple--text"
        >
          Transactions page
        </Link>
        <span> to label your transactions</span>
      </p>

      {data.length > 0 ? (
        <>
          <div style={{ position: "relative" }}>
            <ResponsiveContainer
              width="100%"
              height="370px"
              aspect={1}
              className="revenue-analytics__chart"
            >
              <PieChart>
                <Pie
                  data={data}
                  outerRadius={130}
                  innerRadius={100}
                  dataKey="total"
                  nameKey="tag_name"
                >
                  {data.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  wrapperStyle={{ border: "none", outline: "none" }}
                  content={<RevenueTooltip sumOfTags={sumOfTags} />}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className="revenue-analytics__total">
              <p className="mb-1" style={{ fontSize: "14px" }}>
                Total
              </p>
              <h5>
                {formatCurrency({
                  value: sumOfTags,
                  currencyCode: currency_code,
                })}
              </h5>
            </div>
          </div>
          {/* legend section */}
          <div className="revenue-analytics__legend">
            {data.map(({ total, tag_name }, index) => (
              <div className="revenue-analytics__legend-item" key={index}>
                <span
                  style={{ background: COLORS[index % COLORS.length] }}
                  className="indicator mr-2"
                ></span>
                <span className="title">{tag_name}</span>
                <span className="value font-weight-semibold">
                  {((total / sumOfTags) * 100).toFixed(2)}%
                </span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="mt-5 text-center">
          <img width={"150px"} src={Images.tagEmptyState} alt="revenue tags" />
          <p className="font-weight-semibold mt-3 dark--text">
            No data available
          </p>
        </div>
      )}
    </div>
  );
};

export default RevenueAnalytics;
